export default {"src":"/_next/static/media/rp-cvss.3094164d.svg","height":35,"width":101,"blurWidth":0,"blurHeight":0};